import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const approvedDevelopers = [
  { name: 'Bashundhara Group', license: 'RAJUK-DEV-2001-0001', status: 'Active', projects: 34, completionRate: 96, violations: 0, rating: 4.8, city: 'Dhaka' },
  { name: 'BRAC Enterprises', license: 'RAJUK-DEV-2003-0018', status: 'Active', projects: 22, completionRate: 98, violations: 0, rating: 4.9, city: 'Dhaka' },
  { name: 'Rangs Properties', license: 'RAJUK-DEV-2005-0045', status: 'Active', projects: 19, completionRate: 94, violations: 1, rating: 4.4, city: 'Dhaka' },
  { name: 'Sheltech (Pvt.) Ltd.', license: 'RAJUK-DEV-2002-0012', status: 'Active', projects: 28, completionRate: 97, violations: 0, rating: 4.7, city: 'Dhaka' },
  { name: 'Eastern Housing Ltd.', license: 'RAJUK-DEV-2000-0003', status: 'Active', projects: 41, completionRate: 95, violations: 2, rating: 4.3, city: 'Dhaka' },
  { name: 'Chittagong Development Authority', license: 'CDA-DEV-2001-0001', status: 'Active', projects: 15, completionRate: 93, violations: 1, rating: 4.2, city: 'Chittagong' },
  { name: 'Meghna Group', license: 'RAJUK-DEV-2008-0112', status: 'Active', projects: 12, completionRate: 91, violations: 2, rating: 4.0, city: 'Chittagong' },
  { name: 'XYZ Constructions Ltd.', license: 'RAJUK-DEV-2021-7890', status: 'Suspended', projects: 2, completionRate: 18, violations: 6, rating: 1.5, city: 'Dhaka' }
];

const LandOwnershipValidation = () => {
  const [search, setSearch] = useState('');
  const [selected, setSelected] = useState(null);
  const [cityFilter, setCityFilter] = useState('All');

  const filtered = approvedDevelopers?.filter(d => {
    const matchesSearch = d?.name?.toLowerCase()?.includes(search?.toLowerCase()) || d?.license?.toLowerCase()?.includes(search?.toLowerCase());
    const matchesCity = cityFilter === 'All' || d?.city === cityFilter;
    return matchesSearch && matchesCity;
  });

  const getRatingColor = (r) => r >= 4.5 ? '#22c55e' : r >= 3.5 ? '#f59e0b' : '#ef4444';
  const getStatusStyle = (s) => s === 'Active' ? { color: '#22c55e', bg: 'rgba(34,197,94,0.1)' } : { color: '#ef4444', bg: 'rgba(239,68,68,0.1)' };

  return (
    <div className="rounded-2xl p-6" style={{ background: 'rgba(10,22,40,0.9)', border: '1px solid rgba(0,180,80,0.2)' }}>
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ background: 'rgba(0,180,80,0.1)', border: '1px solid rgba(0,180,80,0.3)' }}>
          <Icon name="Building2" size={20} color="#00B450" />
        </div>
        <div>
          <h3 className="text-lg font-bold" style={{ color: '#E8F4FF' }}>Land Ownership & Developer Validation</h3>
          <p className="text-xs" style={{ color: '#6B9EC4' }}>RAJUK & CDA registered developer database with track records</p>
        </div>
      </div>

      {/* City Filter */}
      <div className="flex gap-2 mb-4">
        {['All', 'Dhaka', 'Chittagong']?.map(city => (
          <button
            key={city}
            onClick={() => setCityFilter(city)}
            className="px-3 py-1.5 rounded-lg text-xs font-medium transition-all"
            style={{
              background: cityFilter === city ? 'rgba(0,180,80,0.15)' : 'rgba(0,180,80,0.04)',
              border: `1px solid ${cityFilter === city ? 'rgba(0,180,80,0.5)' : 'rgba(0,180,80,0.15)'}`,
              color: cityFilter === city ? '#00B450' : '#6B9EC4'
            }}
          >
            {city === 'Dhaka' ? '🏙️ Dhaka' : city === 'Chittagong' ? '⚓ Chittagong' : 'All Cities'}
          </button>
        ))}
      </div>

      <input
        type="text"
        value={search}
        onChange={e => setSearch(e?.target?.value)}
        placeholder="Search developer name or license number..."
        className="w-full px-4 py-3 rounded-xl text-sm outline-none mb-4"
        style={{ background: 'rgba(0,180,80,0.05)', border: '1px solid rgba(0,180,80,0.2)', color: '#E8F4FF' }}
      />
      <div className="space-y-2 max-h-96 overflow-y-auto pr-1">
        {filtered?.map((dev, i) => {
          const ss = getStatusStyle(dev?.status);
          const isSelected = selected?.name === dev?.name;
          return (
            <button
              key={i}
              onClick={() => setSelected(isSelected ? null : dev)}
              className="w-full text-left p-4 rounded-xl transition-all"
              style={{ background: isSelected ? 'rgba(0,180,80,0.1)' : 'rgba(0,180,80,0.04)', border: `1px solid ${isSelected ? 'rgba(0,180,80,0.4)' : 'rgba(0,180,80,0.12)'}` }}
            >
              <div className="flex items-center justify-between mb-2">
                <div className="flex items-center gap-2">
                  <span className="font-semibold text-sm" style={{ color: '#E8F4FF' }}>{dev?.name}</span>
                  <span className="text-xs px-1.5 py-0.5 rounded" style={{ background: 'rgba(0,180,80,0.08)', color: '#00B450', fontSize: 10 }}>{dev?.city}</span>
                </div>
                <span className="text-xs px-2 py-0.5 rounded-full" style={{ background: ss?.bg, color: ss?.color }}>{dev?.status}</span>
              </div>
              <div className="flex flex-wrap gap-3 text-xs" style={{ color: '#6B9EC4' }}>
                <span>License: <span style={{ color: '#00B450' }}>{dev?.license}</span></span>
                <span>Projects: {dev?.projects}</span>
                <span>Completion: <span style={{ color: getRatingColor(dev?.completionRate / 20) }}>{dev?.completionRate}%</span></span>
                <span>Violations: <span style={{ color: dev?.violations > 0 ? '#ef4444' : '#22c55e' }}>{dev?.violations}</span></span>
              </div>
              {isSelected && (
                <div className="mt-3 pt-3" style={{ borderTop: '1px solid rgba(0,180,80,0.15)' }}>
                  <div className="flex items-center gap-2 mb-2">
                    <span className="text-xs" style={{ color: '#6B9EC4' }}>RAJUK Rating:</span>
                    <div className="flex gap-0.5">
                      {[1, 2, 3, 4, 5]?.map(s => (
                        <span key={s} style={{ color: s <= Math.round(dev?.rating) ? '#f59e0b' : '#374151', fontSize: 14 }}>★</span>
                      ))}
                    </div>
                    <span className="text-xs font-bold" style={{ color: getRatingColor(dev?.rating) }}>{dev?.rating}/5.0</span>
                  </div>
                  <div className="text-xs" style={{ color: '#6B9EC4' }}>
                    {dev?.violations === 0 ? '✓ No RAJUK violations on record' : `⚠ ${dev?.violations} violation(s) recorded — verify before purchase`}
                  </div>
                </div>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default LandOwnershipValidation;
